'use client';

import { Button } from '@mui/material';
import { useAction } from 'next-safe-action/hooks';
import { type ComponentProps, type FC, useCallback } from 'react';
import { SkipToolAction, type SkipToolResultSchemaT } from './skip-tool.action';
type Tool = {
  id: string;
};
type Props = Omit<ComponentProps<typeof Button>, 'onClick'> & {
  tool: Tool;
  onClick?: (data: SkipToolResultSchemaT | undefined) => void;
};
export const SkipToolBtn: FC<Props> = props => {
  const {
    tool,
    disabled = false,
    onClick = undefined,
    ...rest
  } = props;
  const {
    execute,
    status
  } = useAction(SkipToolAction, {
    onSuccess: ({
      data
    }) => {
      if (onClick) {
        onClick(data);
      }
    }
  });
  const onConnect = useCallback(() => {
    execute({
      toolId: tool.id
    });
  }, [execute, tool.id]);
  return <Button onClick={onConnect} disabled={disabled || status === 'executing'} {...rest} data-sentry-element="Button" data-sentry-component="SkipToolBtn" data-sentry-source-file="skip-tool-btn.tsx" />;
};